/**
 * Article template tokens from the Article Page v3 handoff. Kept as class
 * fragments rather than theme colours so the template can be lifted or
 * retired without touching the site-wide Tailwind config.
 */
export const ARTICLE_TOKENS = {
  ink: 'text-[#14171c]',
  body: 'text-[#3c4249]',
  bodyMuted: 'text-[#5b636b]',
  muted: 'text-[#767d85]',
  mutedLight: 'text-[#8a9199]',
  mutedLighter: 'text-[#a7adb3]',
  chrome: 'text-[#c9ced3]',
  rule: 'border-[#e4e7ea]',
  ruleLight: 'border-[#eef0f2]',
  surfaceTint: 'bg-[#fafbfc]',
  accentText: 'text-[#1f7fc4]',
  accentBorder: 'border-[#3fa9f5]',
  accentTintBg: 'bg-[#f4faff]',
  cta: 'bg-[#ff2f6d] hover:bg-[#e01f59]',
  darkShell: 'bg-[#171b22]',
  darkInner: 'bg-[#2b3038]'
} as const;

export const ACCENT_HEX = '#3fa9f5';
export const CTA_HEX = '#ff2f6d';

// Sticky site header height plus breathing room, per the handoff.
export const STICKY_OFFSET_CLASS = 'top-[84px]';
export const SCROLL_MARGIN_CLASS = 'scroll-mt-[84px]';
